import React, { useState } from 'react';

const AnalyticsFilters = ({ onFilterChange }) => {
    const [filters, setFilters] = useState({
        startDate: '',
        endDate: '',
        feature: '',
        method: '',
        statusCode: ''
    });

    const handleChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const handleApply = () => {
        onFilterChange(filters);
    };

    const handleReset = () => {
        const defaultFilters = { startDate: '', endDate: '', feature: '', method: '', statusCode: '' };
        setFilters(defaultFilters);
        onFilterChange(defaultFilters);
    };

    return (
        <div className="analytics-filters">
            {/* <div className="api-filter-group">
                <label>Start Date</label>
                <input type="date" className="modern-input" name="startDate" value={filters.startDate} onChange={handleChange} />
            </div>
            <div className="api-filter-group">
                <label>End Date</label>
                <input type="date" className="modern-input" name="endDate" value={filters.endDate} onChange={handleChange} />
            </div> */}
            <div className="api-filter-group">
                <label>Feature</label>
                <select name="feature" className="modern-input" value={filters.feature} onChange={handleChange}>
                    <option value="">All Features</option>
                    <option value="Fruits">Fruits</option>
                    <option value="Profile">Profile</option>
                    <option value="Tickets">Tickets</option>
                    <option value="Vaccination">Vaccination</option>
                    <option value="Dashboard">Dashboard</option>
                    <option value="Period Tracking">Period Tracking</option>
                    <option value="Users">Users</option>
                    <option value="Other">Other</option>
                </select>
            </div>
            <div className="api-filter-group">
                <label>Method</label>
                <select name="method" className="modern-input" value={filters.method} onChange={handleChange}>
                    <option value="">All</option>
                    <option value="GET">GET</option>
                    <option value="POST">POST</option>
                    <option value="PUT">PUT</option>
                    <option value="DELETE">DELETE</option>
                </select>
            </div>
            <div className="api-filter-actions">
                <button className="btn-primary" onClick={handleApply}>Apply</button>
                <button className="btn-secondary" onClick={handleReset}>Reset</button>
            </div>
        </div>
    );
};

export default AnalyticsFilters;
